import { useContext, useEffect, useMemo, useState } from 'react';
import { useApolloClient } from '@apollo/client';
import { Filter } from 'src/utils/composeFilter.ts';
import { buildReadableFilterStatus } from 'src/modules/home/buildReadableFilterStatus.ts';
import { getData } from 'src/modules/home/useGetHomeData.ts';
import { getHomePageConfig } from 'src/modules/home/HomePageMapping.ts';
import { ConfigContext } from 'src/configContext.ts';

export function useGetHomeBreadcrumb({
    filter,
}: {
    filter: Filter;
}) {
    const client = useApolloClient();
    const { userSettings, mandatoryFilterConfig } = useContext(ConfigContext);
    const { query, filterConfig } = useMemo(() => getHomePageConfig(userSettings.currentRegion), [userSettings]);
    const [state, setData] = useState<string>('');
    useEffect(() => {
        getData({
            client,
            query,
            filter,
            filterFamily: filter,
            filterConfig,
            mandatoryFilterConfig,
            currentLocale: userSettings.currentLocale,
            currentRegion: userSettings.currentRegion,
        })
            .then((result) => {
                if (result && result.data) {
                    const readableState = buildReadableFilterStatus(result.filter, result.data);
                    if (readableState.length > 0) {
                        setData(readableState);
                    }
                }
            })
        // eslint-disable-next-line no-console
            .catch((err) => console.error(err));
    }, [
        client,
        query,
        filterConfig,
        filter,
        mandatoryFilterConfig,
        userSettings,
    ]);
    return state;
}
